import {ChangeDetectionStrategy, Component, ElementRef, input, output, viewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-input-search',
    templateUrl: './input-search.component.html',
    styleUrls: ['./input-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule]
})
export class InputSearchComponent {
    private isFocused: boolean;
    value = '';

    public readonly isError = input<boolean>(false);
    public readonly hint = input<string>('');
    public readonly errorMessage = input<string>('');

    public readonly searchEvent = output<string>();
    public readonly modelChange = output<string>();
    public readonly focusChange = output<boolean>();
    public readonly inputField = viewChild.required<ElementRef<HTMLInputElement>>('inputField');

  clear(): void {
    this.value = '';
    this.inputField().nativeElement.blur();
  }

  updateValue(newValue: string): void {
    this.value = newValue;
  }

  onSearch(): void {
    this.searchEvent.emit(this.value);
    this.inputField().nativeElement.blur();
  }

  onModelChange(model: string): void {
    this.modelChange.emit(model);
  }

  onFocus(isFocused: boolean): void {
    this.isFocused = isFocused;
    this.focusChange.emit(isFocused);
  }

  focus(): void {
    this.inputField().nativeElement.focus();
  }

  getClassList() {
    return {
      active: this.isFocused || this.value,
      valid: this.value.length > 2,
      error: this.isError()
    };
  }
}
